import { createAction, props } from '@ngrx/store';
import { LocationActivePasses } from '../../models/LocationActivePasses';

export enum LocationActivePassesActionTypes {
	Load = '[Location Active Passes] Load Location Active Passes',
	LoadSuccess = '[Location Active Passes] Load Location Active Passes Success',
	LoadFailure = '[Location Active Passes] Load Location Active Passes Failure',
	ReceiveLiveLocationActivePasses = '[Location Active Passes] Receive Live Location Active Passes',
}

export const loadLocationActivePasses = createAction(LocationActivePassesActionTypes.Load);

export const loadLocationActivePassesSuccess = createAction(LocationActivePassesActionTypes.LoadSuccess, props<{ data: LocationActivePasses[] }>());

export const loadLocationActivePassesFailure = createAction(LocationActivePassesActionTypes.LoadFailure, props<{ error: unknown }>());

export const receiveLiveLocationActivePasses = createAction(
	LocationActivePassesActionTypes.ReceiveLiveLocationActivePasses,
	props<{ data: LocationActivePasses }>()
);
